import type { ApplicantCard } from '@/hooks/use-opportunity-applicants'

/** Rank map keyed by application id (1 = highest match score). */
export function buildApplicantRankByApplicationId(
  applicants: ApplicantCard[],
): Map<string, number> {
  const ranked = applicants
    .filter((applicant) => typeof applicant.match_score === 'number')
    .sort((a, b) => b.match_score! - a.match_score!)
  return new Map(ranked.map((applicant, index) => [applicant.id, index + 1]))
}
